// URLs
export const URL_LOGIN = "/login";
export const DEFAULT_APP_DOWNLOAD_LINK =
  "https://catch.onelink.me/N79h/DownloadAppFooter";
export const URL_CATCH_LOGO_SEO =
  "https://s.catch.com.au/static/catch/images/catch-logo-e7014ee2c7.png";

// schedule entry
export const SCHEDULE_ENTRY_STYLE_SMALL = "small";
